<ejs-multiselect  #multiselect
                  [allowFiltering]="true"
                  [dataSource]="data"
                  [(value)]="outputValue"
                  [placeholder]="placeholder | translate"
                  [fields]="fieldsSettings">
</ejs-multiselect>
